<template>
  <div class="main">
    <div class="banner">
      <img class="bar_img" src="@/img/banner.png" alt="" />
      <div class="banner_title">{{ $t("index.banner.title") }}</div>
      <div class="banner_content1">
        {{ $t("index.banner.content1") }}
      </div>
      <div class="banner_content2">
        {{ $t("index.banner.content2") }}
      </div>
    </div>
    <div class="fanctions">
      <img class="fanctions_img" src="@/img/fanctions.png" alt="" />
      <div class="fanctions_header">
        <div class="fanctions_header_name">
          {{ $t("index.fanctions.name") }}
        </div>
        <div class="fanctions_header_line"></div>
      </div>
      <div class="fanctions_box">
        <div class="fanctions_title">{{ $t("index.fanctions.title") }}</div>
        <div class="fanctions_content">{{ $t("index.fanctions.content") }}</div>
      </div>
    </div>
    <div class="advantages">
      <img class="advantages_img" src="@/img/advantages.png" alt="" />
      <div class="advantages_header">
        <div class="advantages_header_name">
          {{ $t("index.advantages.name") }}
        </div>
        <div class="advantages_header_line"></div>
      </div>
      <div class="advantages_box">
        <img class="advantages_box_img" src="@/img/01.png" alt="" />
        <div class="advantages_title">{{ $t("index.advantages.title") }}</div>
        <div class="advantages_content">
          {{ $t("index.advantages.content1") }}
        </div>
        <div class="advantages_content2">
          {{ $t("index.advantages.content2") }}
        </div>
      </div>
    </div>
    <div class="sdk">
      <img class="sdk_img" src="@/img/sdk.png" alt="" />
      <div class="sdk_header">
        <img class="sdk_header_img" src="@/img/02.png" alt="" />
        <div class="sdk_header_name">
          {{ $t("index.sdk.name") }}
        </div>
      </div>
      <div class="sdk_box">
        <div class="sdk_box_list">
          <img class="sdk_box_list_img" src="@/img/advertising.png" alt="" />
          <div class="sdk_box_list_content">
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.advertising.content1") }}
            </div>
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.advertising.content2") }}
            </div>
          </div>
        </div>
        <div class="sdk_box_list">
          <img class="sdk_box_list_img2" src="@/img/leaderboard.png" alt="" />
          <div class="sdk_box_list_content">
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.leaderboard.content1") }}
            </div>
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.leaderboard.content2") }}
            </div>
          </div>
        </div>
        <div class="sdk_box_list">
          <img class="sdk_box_list_img2" src="@/img/singlen.png" alt="" />
          <div class="sdk_box_list_content">
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.singlen.content1") }}
            </div>
            <div class="sdk_box_list_content_text">
              {{ $t("index.sdk.singlen.content2") }}
            </div>
          </div>
        </div>
      </div>
      <div class="sdk_button">
        <div class="sdk_button_bg">
          <div class="sdk_button_bg_text" @click="handleMenuClick">
            {{ $t("index.sdk.button") }}
          </div>
        </div>
      </div>
    </div>
    <div class="global">
      <div class="shadow">
        <div class="shadow_left"></div>
        <div class="shadow_right"></div>
      </div>
      <img class="global_img" src="@/img/global.png" alt="" />
      <div class="global_header">
        <img class="global_header_img" src="@/img/03.png" alt="" />
        <div class="global_header_name">
          {{ $t("index.global.name") }}
        </div>
        <div class="global_header_title">
          {{ $t("index.global.title") }}
        </div>
      </div>
      <nav class="global_nav">
        <ul class="global_ul">
          <li class="global_li">
            <img class="global_nav_img" src="@/img/game_1.png" alt="" />
          </li>
          <li class="global_li">
            <img class="global_nav_img" src="@/img/game_1.png" alt="" />
          </li>
        </ul>
      </nav>
      <nav class="global_nav2">
        <ul class="global_ul2">
          <li class="global_li2">
            <img class="global_nav_img2" src="@/img/game_2.png" alt="" />
          </li>
          <li class="global_li2">
            <img class="global_nav_img2" src="@/img/game_2.png" alt="" />
          </li>
        </ul>
      </nav>
      <div class="global_header_contet">
        <div class="global_header_contet_text">
          {{ $t("index.global.content1") }}
        </div>
        <div
          class="global_header_contet_text"
          v-if="this.$i18n.locale === 'zh'"
        >
          {{ $t("index.global.content2") }}
        </div>
        <div class="global_carousel">
          <el-carousel autoplay :interval="8000" arrow="always">
            <el-carousel-item>
              <img
                class="global_carousel_img"
                src="@/img/partner_01.png"
                alt=""
              />
            </el-carousel-item>
            <el-carousel-item>
              <img
                class="global_carousel_img"
                src="@/img/partner_02.png"
                alt=""
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="join">
      <img class="join_img" src="@/img/join.png" alt="" />
      <div class="join_box">
        <div class="join_box_title_zh" v-if="this.$i18n.locale === 'zh'">
          <div>{{ $t("index.join.title1") }}</div>
          <div>{{ $t("index.join.title2") }}</div>
        </div>
        <div class="join_box_title_en" v-if="this.$i18n.locale === 'en'">
          <div>{{ $t("index.join.title1") }}</div>
        </div>
        <div class="join_box_button">
          <div class="join_box_button_text" @click="clickrouter('/contact')">
            {{ $t("index.join.button") }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div  @click="load('1')" class="CU" style="width: 100px;height: 100px;background-color: red; margin:100px;">
                     通过认证
                   </div> -->
    <!-- <div  @click="load('1')" class="CU" style="width: 100px;height: 100px;background-color: red; margin:100px;">
                    通过认证
                  </div> -->
    <!--

                <div  @click="load('0')" class="CU" style="width: 100px;height: 100px;background-color: red; ">
                   不通过认证
                </div>

				<div class="bar_url">
									<img class="bar_img" src="@/img/banner.jpg" alt="">
								</div>
				<div  @click="audit('1')" class="CU" style="width: 100px;height: 100px;background-color: red; ">
							  通过审核
							</div>

			  <div  @click="audit('0')" class="CU" style="width: 100px;height: 100px;background-color: red; ">
				不通过审核
			  </div> -->
    <!-- <div  @click="audit('1')" class="CU" style="width: 100px;height: 100px;background-color: red; ">
			  			  通过审核
			  			</div> -->
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { BASE_HOST } from "../config/config";

export default {
  data() {
    return {};
  },
  created() {
    if (localStorage.getItem("mp_lang")) {
      this.$i18n.locale = localStorage.getItem("mp_lang");
    } else {
      localStorage.setItem("mp_lang", "en");
      this.$i18n.locale = "en";
    }
    console.log(this.$i18n.locale);
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("game", ["AgreeCensorInfo2", "CheckCensorApp"]),
    handleMenuClick(e) {
      window.open(`${BASE_HOST}/tga-doc${this.$t("config.h5tgadoc")}`);
    },
    clickrouter(path) {
      var configlink = [
        "/login",
        "/info",
        "/register",
        "/agreement",
        "/forget"
      ];
      if (path == "/file") {
        return;
      }

      if (path == "/index" || path == "/contact") {
      } else {
        if (!localStorage.getItem("mp_accessToken")) {
          this.$message.info(this.$t("footer.to_login"));

          this.$router.push({
            path: "/login"
          });
          return;
        }
        if (configlink.includes(this.$route.path)) {
          this.$message.info(this.$t("footer.to_info"));
          this.$router.push({
            path: "/info"
          });

          return;
        }
      }
      if (this.$route.path == path) {
        return;
      }
      this.$router.push({
        path: path
      });
    },
    async load(index) {
      // AgreeCensorInfo
      var res = await this.AgreeCensorInfo2({
        $axios: this.$axios,
        userId: "642e8821e99e4d5d8c26f96dbcfe4a87",
        token: "at-4adfc66479064a44b746a121d6763d7b-tga"
        // token: '12345!@#$%',
      });
    },
    async audit(index) {
      var res = await this.CheckCensorApp({
        $axios: this.$axios,
        censorId: "030c7b56993b450d9b1b9850ff4a8406",
        appId: "ee2e26c4ab2f40f5a3156edef3403a2f",
        token: "12345!@#$%",
        agree: index
      });
    }
  }
};
</script>
<style>
.main {
  /* padding-top: 65px; */
}
.bar_url {
  width: 100%;
  height: 606px;
}
.banner {
  display: flex;
  position: relative;
}
.bar_img {
  width: 100%;
  height: 514px;
  object-fit: cover;
}
.banner_title {
  position: absolute;
  padding: 180px 0 0 359px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 42px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
}
.banner_content1 {
  position: absolute;
  padding: 268px 0 0 359px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
}
.banner_content2 {
  position: absolute;
  padding: 294px 0 0 359px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
}
.fanctions {
  display: flex;
  position: relative;
}
.fanctions_img {
  width: 100%;
  height: 760px;
  object-fit: cover;
}
.fanctions_header {
  width: 100%;
  position: absolute;
}
.fanctions_header_name {
  padding-top: 97px;
  font-family: MicrosoftYaHei;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
  text-align: center;
}
.fanctions_header_line {
  margin: 0 auto;
  width: 50px;
  height: 6px;
  background-color: #4990fa;
  border-radius: 3px;
}
.fanctions_box {
  position: absolute;
  margin: 351px 0 0 360px;
}
.fanctions_title {
  font-family: MicrosoftYaHei;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 42px;
  color: #2b3543;
  width: 485px;
}
.fanctions_content {
  margin-top: 25px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
  width: 542px;
}

.advantages {
  display: flex;
  position: relative;
}
.advantages_img {
  width: 100%;
  height: 780px;
  object-fit: cover;
}
.advantages_header {
  width: 100%;
  position: absolute;
}
.advantages_header_name {
  padding-top: 97px;
  font-family: MicrosoftYaHei;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 78px;
  letter-spacing: 0px;
  color: #2b3543;
  text-align: center;
}
.advantages_header_line {
  margin: 0 auto;
  width: 50px;
  height: 6px;
  background-color: #4990fa;
  border-radius: 3px;
}
.advantages_box {
  position: absolute;
  top: 348px;
  right: 362px;
  text-align: right;
}
.advantages_box_img {
  width: 85px;
  height: 62px;
  object-fit: cover;
  position: absolute;
  right: 0;
}
.advantages_title {
  right: 0;
  padding-top: 40px;
  font-family: MicrosoftYaHei;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #2b3543;
}
.advantages_content {
  padding-top: 27px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
  width: 615px;
}
.advantages_content2 {
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
  width: 615px;
}
.sdk {
  display: flex;
  position: relative;
}
.sdk_img {
  width: 100%;
  height: 800px;
  object-fit: cover;
}
.sdk_header {
  width: 100%;
  position: absolute;
}
.sdk_header_img {
  width: 108px;
  height: 62px;
  object-fit: cover;
  position: absolute;
  margin-top: 102px;
  margin-left: -54px;
  left: 50%;
}
.sdk_header_name {
  padding-top: 150px;
  font-family: MicrosoftYaHei;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  color: #2b3543;
  text-align: center;
}
.sdk_box {
  position: absolute;
  z-index: 2;
  display: flex;
  margin: 274px 0 0 315px;
}
.sdk_box_list {
  margin-left: 45px;
  width: 370px;
  height: 350px;
  background-color: #ffffff;
  border-radius: 30px;
}
.sdk_box_list:hover {
  box-shadow: 0px 2px 50px 0px rgba(0, 0, 0, 0.1);
}
.sdk_box_list_img {
  width: 253px;
  height: 194px;
  margin: 36px 58px;
  position: absolute;
}
.sdk_box_list_img2 {
  width: 196px;
  height: 158px;
  margin: 54px 87px;
  position: absolute;
}
.sdk_box_list_content {
  padding-top: 265px;
}
.sdk_box_list_content_text {
  text-align: center;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 26px;
  letter-spacing: 0px;
  color: #646a73;
}
.sdk_button {
  width: 100%;
  position: absolute;
  padding-top: 674px;
}
.sdk_button_bg {
  width: 159px;
  height: 48px;
  border-radius: 24px;
  border: solid 1px #b8bfcf;
  margin: 0 auto;
  cursor: pointer;
}
.sdk_button_bg:hover {
  border: solid 1px #4990fa;
}
.sdk_button_bg_text:hover {
  color: #4990fa;
}
.sdk_button_bg_text {
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  color: #646a73;
  text-align: center;
}

.global {
  display: flex;
  position: relative;
}
.global_img {
  width: 100%;
  height: 800;
  object-fit: cover;
}
.global_header {
  width: 100%;
  position: absolute;
}
.global_header_img {
  width: 108px;
  height: 62px;
  object-fit: cover;
  position: absolute;
  margin-top: 102px;
  margin-left: -54px;
  left: 50%;
}
.global_header_name {
  padding-top: 150px;
  font-family: MicrosoftYaHei;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  color: #2b3543;
  text-align: center;
}
.global_header_title {
  padding-top: 90px;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  color: #646a73;
  text-align: center;
}
.global_nav {
  position: absolute;
  width: 100%;
  overflow: hidden;
  padding-top: 331px;
}
.global_ul {
  list-style: none;
  width: 200%;
  height: 100%;
  animation: picmove 30s linear infinite forwards;
}
@keyframes picmove {
  from {
    transform: translate(0);
  }
  to {
    transform: translate(-1820px);
  }
}
.global_nav_img {
  width: 1820px;
  height: 88px;
  float: left;
}
.global_ul:hover {
  animation-play-state: paused;
}
.global_nav2 {
  position: absolute;
  width: 100%;
  overflow: hidden;
  padding-top: 446px;
}
.global_ul2 {
  list-style: none;
  width: 200%;
  height: 100%;
  animation: picmove2 30s linear infinite forwards;
}
@keyframes picmove2 {
  from {
    transform: translate(-1820px);
  }
  to {
    transform: translate(0);
  }
}
.global_nav_img2 {
  width: 1820px;
  height: 88px;
  float: left;
}
.global_ul2:hover {
  animation-play-state: paused;
}
.global_header_contet {
  position: absolute;
  width: 100%;
  padding-top: 623px;
}
.global_header_contet_text {
  text-align: center;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #646a73;
}
.global_carousel {
  width: 1370px;
  padding-top: 40px;
  position: absolute;
  margin-left: -695px;
  left: 50%;
}
.global_carousel_img {
  padding-left: 80px;
}
.join {
  display: flex;
  position: relative;
}
.join_img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
.join_box {
  position: absolute;
  width: 100%;
  padding-top: 100px;
  display: flex;
}
.join_box_title_zh {
  position: absolute;
  padding-left: 360px;
  font-family: MicrosoftYaHei;
  font-size: 36px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 54px;
  letter-spacing: 2px;
  color: #2b3543;
  margin-top: -20px;
}
.join_box_title_en {
  position: absolute;
  padding-left: 360px;
  font-family: MicrosoftYaHei-Bold;
  font-size: 60px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 54px;
  letter-spacing: 3px;
  color: #2b3543;
}
.join_box_button {
  margin-left: 1355px;
  width: 160px;
  height: 48px;
  background-color: #4990fa;
  border-radius: 24px;
  cursor: pointer;
}
.join_box_button_text {
  font-family: MicrosoftYaHei;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 48px;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
}
.join_box_button:hover {
  background-color: #66a8ff;
}
.shadow {
  height: 100%;
  z-index: 2;
}
.shadow_left {
  position: absolute;
  height: 100%;
  left: 0;
  width: 200px;
  background-image: linear-gradient(
    to right,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
}
.shadow_right {
  position: absolute;
  height: 100%;
  right: 0;
  width: 200px;
  background-image: linear-gradient(
    to left,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 0)
  );
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue